import { removeInvestorFromMip } from '@dealstack/frontend/shared/dataExchange/services/mip-manage.service';
import { useMutation } from '@tanstack/react-query';

export const useManageInvestorSectionController = (
	navigateToTable: () => void,
	investorId?: string
) => {
	const removeInvestorMutation = useMutation({
		mutationFn: removeInvestorFromMip,

		onSuccess: () => {
			navigateToTable();
		},
	});

	const removeInvestor = () => {
		if (!investorId) {
			return;
		}
		removeInvestorMutation.mutate(investorId);
	};

	return { removeInvestor };
};
